import Vue from "vue";
import VueRouter from "vue-router";

import HomePage from "@/components/pages/HomePage.vue";
import Ensayo from "@/views/Ensayo.vue"
import Hornos from "@/views/Hornos.vue"
import History from "@/views/History.vue"
import Informes from "@/views/Informes.vue";
import HistoryModifications from "@/views/HistoryModifications.vue";
import GestionUsuarios from "@/views/GestionUsuarios.vue";
import ViewHMI from "@/views/ViewHMI.vue";
import Secadero from "@/views/Secadero.vue";
import Login from "@/views/Login.vue";
import Configuracion from "@/views/Configuracion.vue";


Vue.use(VueRouter);

const routes = [
  {
    path: "/secadero_scada",
    name: "home",
    component: HomePage,
    meta: {
      requiresAuth: true,
      title: process.env.VUE_APP_TITLE,
      metaTags: [
        {
          name: "Página principal",
          content: "Página principal de " + process.env.VUE_APP_COMPANY,
        },
      ],
    },
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: {
      title: process.env.VUE_APP_TITLE,
      metaTags: [
        {
          name: "Login",
          content: "Página de login de " + process.env.VUE_APP_COMPANY,
        },
      ],
    },
  },
  {
    path: '/',
    name: 'Principal',
    component: Ensayo,
    meta:{
      requiresAuth: true,
      title: 'Eggnovo',
      metaTags: [
        {
          name: 'Home',
          content: 'Página principal de la app para Eggnovo' 
        },
      ]
    }
  },
  ,
  {
    path: '/hornos',
    name: 'Hornos',
    component: Hornos,
    meta:{
      requiresAuth: true,
      title: 'Eggnovo',
      metaTags: [
        {
          name: 'Hornos',
          content: 'Página de hornos de la app para Eggnovo' 
        },
      ]
    }
  },
  ,
  {
    path: '/history',
    name: 'History',
    component: History,
    meta:{
      requiresAuth: true,
      title: 'Eggnovo',
      metaTags: [
        {
          name: 'History',
          content: 'Página de historicos de la app para Eggnovo' 
        },
      ]
    }
    
  },
  {
    path: '/informes',
    name: 'Informes',
    component: Informes,
    meta:{
      requiresAuth: true,
      title: 'Eggnovo',
      metaTags: [
        {
          name: 'Informes',
          content: 'Página de informes de la app para Eggnovo' 
        },
      ]
    }
  },
  {
    path: '/modifications',
    name: 'HistoricoModificaciones',
    component: HistoryModifications,
    meta:{
      requiresAuth: true,
      title: 'Eggnovo',
      metaTags: [
        {
          name: 'Modifications',
          content: 'Página de modificaciones de la app para Eggnovo' 
        },
      ]
    }
  },
  {
    path: '/users',
    name: 'GestionUsuarios',
    component: GestionUsuarios,
    meta:{
      requiresAuth: true,
      title: 'Eggnovo',
      metaTags: [
        {
          name: 'Users',
          content: 'Página de gestion de usuarios de la app para Eggnovo' 
        },
      ]
    }
  },
  {
    path: '/hmi',
    name: 'HMI',
    component: ViewHMI,
    meta:{
      requiresAuth: true,
      title: 'Eggnovo',
      metaTags: [
        {
          name: 'HMI',
          content: 'Página de HMI de la app para Eggnovo' 
        },
      ]
    }
  },
  {
    path: '/secadero',
    name: 'Secadero',
    component: Secadero,
    meta:{
      requiresAuth: true,
      title: 'Secadero',
      metaTags: [
        {
          name: 'Secadero',
          content: 'Página de datos en tiempo real para el secadero' 
        },
      ]
    }
  },
  {
    path: '/configuracion',
    name: 'Configuracion',
    component: Configuracion,
    meta:{
      requiresAuth: true,
      title: 'Eggnovo',
      metaTags: [
        {
          name: 'Configuracion',
          content: 'Página de configuracion de la app para Eggnovo' 
        },
      ]
    }
  },
  

];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = `${to.meta.title} - ${to.meta.metaTags[0].name}`;
  }

  const loggedIn = localStorage.getItem("token");
  if (to.matched.some((record) => record.meta.requiresAuth) && !loggedIn) {
    next({ name: "login" });
  } else {
    next();
  }
});

export default router;
